import { store } from "store";

import {
  OtpRecord,
  setOtpRecords,
} from "store/features/otpRecord/otpRecordSlice";

export const sortOtpRecords = (otpRecords: OtpRecord[]): OtpRecord[] => {
  return [...otpRecords].sort((a, b) => {
    if (a.isUsed && !b.isUsed) {
      return 1;
    }
    if (!a.isUsed && b.isUsed) {
      return -1;
    }

    return b.expiresIn - a.expiresIn;
  });
};

export const updateOtpRecordInState = (
  id: string,
  updatedData: Partial<OtpRecord>,
) => {
  const { otpRecords } = store.getState().otpRecord;

  const updatedOtpRecords = otpRecords.map((otpRecord) =>
    otpRecord.id === id ? { ...otpRecord, ...updatedData } : otpRecord,
  );

  store.dispatch(setOtpRecords(updatedOtpRecords));
};
